import { createApp } from 'vue';
import '@/style/global.scss';
import App from './App.vue';
import { addBizRouter, getRouter } from './router';
import sc from '@/components/common';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
import { serviceManager } from '@/components/business/crud/service/ServiceManager';
import { RequireContextHelper } from '@/util/RequireContextHelper';
import { monacoInit } from '@/util/monaco';

serviceManager.setService(
  'management',
  'table',
  RequireContextHelper.toTree(
    require.context('./views/management', true, /Table.ts$/, 'sync')
  )
);
serviceManager.setService(
  "management",
  "form",
  RequireContextHelper.toTree(
    require.context("./views/management", true, /Form.ts$/, "sync")
  )
);
serviceManager.setService(
    "management",
    "search",
    RequireContextHelper.toTree(
        require.context("./views/management", true, /Search.ts$/, "sync")
    )
);
monacoInit().then(getRouter).then((router) => {
  addBizRouter().finally(() => {
    createApp(App).use(router).use(sc).use(Antd).mount("#app")
  })
});
